import React, { useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import DropDownPicker from 'react-native-dropdown-picker';
import { OA_Available_Invoice_Month } from '../../api/type/type';
import Query from '../../api/queries';

const MonthSelector = ({ additionalStyle = {}, value, onChange, editable = true }) => {
    const [open, setOpen] = useState(false);
    const [months, setMonth] = useState<OA_Available_Invoice_Month[]>([]);
    const query = new Query();
    const styles = StyleSheet.create({
        container: {
            ...additionalStyle
        },
        itemSeparator: {
            backgroundColor: 'silver',
            alignSelf: "center",
            width: "90%"
        },
        picker: {
            borderWidth: 1,
            borderColor: 'silver',
            borderRadius: 15,
            //backgroundColor: "#FFF0FA",
        },
        text: {
            textAlign: "center",
            fontSize: 18,
        },
    });

    useEffect(() => {
        const fetchMonths = async () => {
            try {
                const response = await query.getAvailableInvoiceMonths();
                if (response.data?.OA_getAvailableInvoiceMonths) {
                    setMonth(response.data.OA_getAvailableInvoiceMonths);
                }
            } catch (error) {
                console.error('Erreur lors de la récupération des mois disponibles:', error);
            }
        };

        fetchMonths();
    }, []);

    return (
        <View style={styles.container}>
            <DropDownPicker
                open={open}
                value={value || (months.length > 0 ? months[0].value : null)}
                items={months.map(month => ({
                    label: month.label || '',
                    value: month.value
                }))}
                setItems={setMonth}
                placeholder={months?.[0]?.label || ''}
                setOpen={setOpen}
                setValue={onChange}
                style={styles.picker}
                itemSeparator
                itemSeparatorStyle={styles.itemSeparator}
                dropDownContainerStyle={{ borderColor: "silver", }}
                textStyle={styles.text}
                onChangeValue={(itemValue) => {
                    if (onChange) {
                        onChange(itemValue);
                    }
                }}
                disabled={!editable}
                listMode="SCROLLVIEW"
                dropDownDirection="BOTTOM"
            />
        </View>
    );
};

export default MonthSelector;